import {init} from "../utils/_livesearch";
import {getParams} from "dauphine-js/src/utils";

const settings = {
    radioSelector: "[js-radio]",
    radioAttribute: "js-radio",
    labelSelector: "[js-label]",
    filtersSelector: "[js-filters]",
    openFiltersSelector: "[js-filters-open]",
    resetSelector: "[js-reset]",
    validatesSelector: "[js-validate]",
    openFiltersClass: "open"
}

const radios = document.querySelectorAll(settings.radioSelector);
const newsForm = document.querySelector('[js-news]');

const state = {activeValue: null};

if (newsForm) {

    /**
     * Init Livesearch
     * @type {*}
     */
    const livesearch = init({
        infiniteScroll: true,
        manualInfiniteScroll: true,
        moreButtonText: "En voir plus"
    });

    /**
     * Handle filters reset
     */
    const resetFilters = () => {
        state.activeValue = null;
        livesearch.reset()
    }

    /**
     * Handle check / uncheck radios
     */
    const queryParams = getParams(window.location).category;

    if (queryParams) {
        state.activeValue = queryParams;
    }

    if (radios) {
        radios.forEach(radio => {
            radio.addEventListener('click', ({target}) => {
                if (state.activeValue === radio.value) {
                    radio.checked = false;
                    resetFilters();
                } else {
                    state.activeValue = radio.value
                }
            })
        })
    }

    /**
     * Handle filters on mobile
     */
    const filters = document.querySelector(settings.filtersSelector);
    const validateButton = document.querySelector(settings.validatesSelector);
    const openButton = document.querySelector(settings.openFiltersSelector);
    const resetButton = document.querySelector(settings.resetSelector);

    if (filters) {
        validateButton.addEventListener('click', () => {
            filters.classList.remove(settings.openFiltersClass)
        });

        openButton.addEventListener('click', () => {
            filters.classList.add(settings.openFiltersClass)
        });

        resetButton.addEventListener('click', () => {
            resetFilters();
        });
    }
}
